module.exports = __webpack_public_path__ + "img/cancelled.ca203e5e.svg";